<script setup lang="ts">
import { repository } from "~/repository";
import { map } from "lodash-es";
import TrainingFilter from "~/components/Training/TrainingFilter.vue";
import type { TrainingFilterFormModel } from "~/components/Training/TrainingFilter.vue";
import { isEqual } from "lodash-es";
import { getThumbnailImage } from "~/utils/common";
import type { Collection } from "~/types";

const showFilters = ref(false);
const initialFilterFormModel = {
  gameType: "",
  mostRecent: false,
  coaches: "",
};
const filterFormModel = ref<TrainingFilterFormModel>({
  ...initialFilterFormModel,
});

const { data, pending, refresh } = await useAsyncData(
  async () => {
    // if (isEqual(filterFormModel.value, initialFilterFormModel)) {
    const { data } = await repository.common.fetchViewData({
      viewName: "training",
    });
    return data.collection_list || [];
    // } else {
    //   const { data } = await repository.common.fetchTrainingFilteredResults({
    //     game_type: [filterFormModel.value.gameType],
    //     most_recent: false,
    //     coaches: [filterFormModel.value.coaches],
    //   });
    //   return data.videos || [];
    // }
  },
  {
    lazy: true,
    transform: (e) => {
      const items = e || [];

      return map(items, (item) => {
        const thumbnailImage =
          item?.pre_air_images?.length > 0
            ? item.pre_air_images[0].url
            : item.images[0].url;
        return {
          ...item,
          thumbnailImage,
        };
      });
    },
  },
);

function initFilterSearch() {
  refresh();
  showFilters.value = false;
}
</script>

<template>
  <div>
    <div class="">
      <div class="mb-2 text-center text-4xl font-bold">
        Elevate your game and gain an edge over the competition with our VIP
        Training
      </div>
      <div class="text-center text-lg text-surface-300">
        Package, specially designed for the most dedicated poker enthusiasts.
      </div>
      <div v-if="pending" class="mt-20 text-center">
        <ProgressSpinner class="!h-20 !w-20" />
      </div>
      <div v-else class="mt-10">
        <!--      <TrainingFilter-->
        <!--        v-model:visible="showFilters"-->
        <!--        v-model:form-model="filterFormModel"-->
        <!--        @init-filter-search="initFilterSearch"-->
        <!--      />-->
        <!--      <div class="text-right mb-5">-->
        <!--        <Button-->
        <!--          outlined-->
        <!--          label="FILTERS"-->
        <!--          :pt-options="{ mergeProps: true }"-->
        <!--          :pt="{-->
        <!--            root: 'border border-white/30 px-6 !py-2',-->
        <!--            label: 'text-white text-xs',-->
        <!--          }"-->
        <!--          @click="showFilters = true"-->
        <!--        >-->
        <!--          <template #icon>-->
        <!--            <font-awesome-icon-->
        <!--              :icon="['fas', 'filter']"-->
        <!--              class="text-white text-xs"-->
        <!--            />-->
        <!--          </template>-->
        <!--        </Button>-->
        <!--      </div>-->
        <div v-if="data?.length" class="flex flex-wrap justify-center lg:mx-0">
          <div v-for="item in data" :key="item.id" class="w-1/2 p-3 lg:w-1/3">
            <NuxtLink
              class="block rounded-lg border border-surface-border p-3 hover:bg-primary-900"
              :to="getCollectionLink({ type: item.type, slug: item.label })"
            >
              <div class="mb-2">
                <NuxtImg
                  class="aspect-video"
                  alt="om-demand-thumbnail"
                  :src="getThumbnailImage([item.pre_air_images, item.images])"
                  placeholder="/images/placeholder.png"
                  loading="lazy"
                />
              </div>
              <div class="text-sm">
                {{ item.title }}
              </div>
            </NuxtLink>
          </div>
        </div>
        <div v-else class="text-center text-surface-300">No data</div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
